import { createRouter, createWebHistory } from "vue-router";
import { useAuthStore } from "./stores/auth";
import AppLayout from "./layout/AppLayout.vue";
import LoginView from "./views/LoginView.vue";
import type { MenuCode } from "@pmc350/shared";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: "/login", name: "login", component: LoginView, meta: { public: true } },
    {
      path: "/",
      component: AppLayout,
      children: [
        { path: "", redirect: "/dashboard" },
        { path: "dashboard", name: "dashboard", component: () => import("./views/DashboardView.vue"), meta: { title: "运行总览", menuKey: "dashboard" } },
        { path: "devices", name: "devices", component: () => import("./views/DevicesView.vue"), meta: { title: "设备管理", menuKey: "devices" } },
        { path: "devices/:id", name: "device-detail", component: () => import("./views/DeviceDetailView.vue"), meta: { title: "设备详情", menuKey: "devices" } },
        { path: "raw-protocol", name: "raw-protocol", component: () => import("./views/RawProtocolView.vue"), meta: { title: "原始协议", menuKey: "raw_protocol" } },
        { path: "alarms", name: "alarms", component: () => import("./views/AlarmsView.vue"), meta: { title: "告警中心", menuKey: "alarms" } },
        { path: "personnel", name: "personnel", component: () => import("./views/PersonnelView.vue"), meta: { title: "人员管理", menuKey: "personnel" } },
        { path: "operators", redirect: "/personnel" },
        { path: "audit", name: "audit", component: () => import("./views/AuditView.vue"), meta: { title: "审计日志", menuKey: "audit" } },
        { path: "iot", redirect: "/raw-protocol" },
        { path: "modbus-gateway", name: "modbus-gateway", component: () => import("./views/ModbusGatewayView.vue"), meta: { title: "Modbus 网关", menuKey: "modbus_gateway" } },
        { path: "mqtt-gateway", name: "mqtt-gateway", component: () => import("./views/MqttGatewayView.vue"), meta: { title: "MQTT 网关", menuKey: "mqtt_gateway" } },
        { path: "exports", name: "exports", component: () => import("./views/ExportsView.vue"), meta: { title: "导出任务", menuKey: "exports" } },
        { path: "settings", name: "settings", component: () => import("./views/SystemSettingsView.vue"), meta: { title: "参数配置", menuKey: "settings" } },
        { path: "no-access", name: "no-access", component: () => import("./views/NoAccessView.vue"), meta: { title: "功能菜单" } },
      ],
    },
  ],
});

router.beforeEach(async (to) => {
  if (to.meta.public) return true;
  const auth = useAuthStore();
  if (!auth.authenticated) {
    if (!await auth.restore()) return { name: "login", query: { redirect: to.fullPath } };
  } else if (!await auth.restore()) {
    return { name: "login", query: { redirect: to.fullPath } };
  }
  const menuKey = to.meta.menuKey as MenuCode | undefined;
  if (menuKey && !auth.canAccess(menuKey)) return auth.homePath;
  if (to.name === "no-access" && auth.homePath !== "/no-access") return auth.homePath;
  return true;
});

export default router;
